export default "__VITE_ASSET__B_ahKD8w__"